<template>
  <div>
    <div class="weather">
      <div class="weather-item">
        <div class="weather-item-label">
          天气
        </div>
        <div class="weather-item-line">
          <div class="weather-item-content">
            {{ (workLog.weather && workLog.weather !== '') ?
              workLog.weather : weather.weather }}
          </div>
        </div>
      </div>
      <div class="weather-item">
        <div class="weather-item-label">
          温度
        </div>
        <div class="weather-item-line">
          <div class="weather-item-content">
            {{ (workLog.temperature && workLog.temperature !== '') ?
              workLog.temperature : weather.temperature }}
          </div>
        </div>
      </div>
      <div class="weather-item">
        <div class="weather-item-label">
          风力
        </div>
        <div class="weather-item-line" style="border-right: none;">
          <div class="weather-item-content">
            <span v-show="workLog.windDirection || weather.windDirection">
              {{ (workLog.windDirection && workLog.windDirection !== '') ?
                workLog.windDirection : weather.windDirection }} 风
            </span>
            <span v-show="workLog.windPower || weather.windPower">
              {{ (workLog.windPower && workLog.windPower !== '') ?
                workLog.windPower : weather.windPower }} 级
            </span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div class="textarea-label">
          <div class="textarea-label-text">
            工作安排
          </div>
        </div>
        <div class="textarea-item">
          {{ workLog.jobPlan || '暂无' }}
        </div>
      </div>
      <div>
        <div class="textarea-label">
          <div class="textarea-label-text">
            事项记录
          </div>
        </div>
        <div class="textarea-item">
          {{ workLog.itemRecord || '暂无' }}
        </div>
      </div>
      <div>
        <div class="textarea-label">
          <div class="textarea-label-text">
            技术、质量、安全要求
          </div>
        </div>
        <div class="textarea-item">
          {{ workLog.itemRequire || '暂无' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['workLog', 'weather'],
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .weather {
    margin: 0.5rem 0rem;
    height: 4rem;
    background-color: $panel-bg-color;
    border-radius: 0.3rem;
    display: flex;
  }

  .weather-item {
    padding: 0.3rem 0rem;
    position: relative;
    text-align: center;
    width: 33.33333333%;
  }

  .weather-item-label {
    position: absolute;
    left: 0.5rem;
    top: 0.5rem;
    color: $second-font-color;
    font-size: 0.8rem;
  }

  .weather-item-line {
    border-right: 0.05rem solid $border-color;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .weather-item-content {
    padding-top: 0.5rem;
  }

  .textarea-label {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .textarea-label-text {
    flex: auto;
    padding-left: 0.5rem;
    font-size: 1rem;
    min-height: 2rem;
    height: 2rem;
    line-height: 2rem;
  }

  .textarea-item {
    margin-left: 0.5rem;
    padding: 0rem 1rem;
    font-size: 0.8rem;
    color: $second-font-color;
  }
</style>



// WEBPACK FOOTER //
// src/pages/workLog/logView.vue